import { useState, useRef, useEffect, useCallback } from 'react';
import { Input } from '@/components/ui/input';

interface TimeCellEditorProps {
  value: unknown;
  ariaLabel?: string;
  onChange: (value: string | null) => void;
  onCommit: () => void;
  onCancel: () => void;
}

export function TimeCellEditor({ value, ariaLabel, onChange, onCommit, onCancel }: TimeCellEditorProps) {
  const [localValue, setLocalValue] = useState(value != null ? String(value) : '');
  const inputRef = useRef<HTMLInputElement>(null);
  const localValueRef = useRef(localValue);
  localValueRef.current = localValue;
  const committedRef = useRef(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const commit = useCallback(() => {
    if (committedRef.current) return;
    committedRef.current = true;
    onChange(localValueRef.current || null);
    onCommit();
  }, [onChange, onCommit]);

  return (
    <Input
      ref={inputRef}
      type="time"
      value={localValue}
      aria-label={ariaLabel}
      onChange={e => setLocalValue(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') { commit(); }
        if (e.key === 'Tab' && !committedRef.current) {
          committedRef.current = true;
          onChange(localValueRef.current || null);
        }
        if (e.key === 'Escape') { onCancel(); }
      }}
      onBlur={commit}
      className="cell-editing-input text-xs font-mono"
    />
  );
}
